import ExtLinkLogo from './ExtLinkLogo';

export default ExtLinkLogo;
